import script from "./ImageLegend.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageLegend.vue?vue&type=script&lang=ts&setup=true"

import "./ImageLegend.vue?vue&type=style&index=0&id=1ae22ad2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ae22ad2"]])

export default __exports__